<template>
  <base-dialog
    :visible.sync="dialogVisible"
    class="due-reason-dialog"
    border-radius="none"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="500px"
  >
    <template v-slot:header>
      <div class="header-wrap">
        <div class="title">
          填写 逾期原因
        </div>
      </div>
    </template>
    <el-form class="over-due-form">
      <el-form-item label="逾期原因" label-width="100px" required>
        <el-select placeholder="请选择" v-model="from.overDueReason">
          <el-option
            v-for="(item, index) in overDueReasonList"
            :value="item"
            :label="item"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="逾期备注" label-width="100px">
        <el-input
          placeholder="请输入内容"
          v-model="from.overDueRemark"
        ></el-input>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <base-button type="primary" @click="submit">保存</base-button>
      <base-button @click="close">取消</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog.vue"
import BaseButton from "@/components/UIComponents/Button.vue"
import { loadingService } from "@/utils/ui"
import { completeTask } from "@/api/project/task"

export default {
  name: "DueReasonDialog",
  components: { BaseButton, BaseDialog },
  props: {
    projectInfo: Object,
    taskId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      title: "",
      from: {
        overDueReason: "",
        overDueRemark: ""
      },
      dialogVisible: false
    }
  },
  computed: {
    overDueReasonList() {
      return this.projectInfo?.overDueReasonList || []
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    async submit() {
      if (this.loading) {
        this.$message.warning("请等待加载完成后操作")
        return
      }
      if (this.from.overDueReason.length === 0) {
        this.$message.warning("请选择逾期原因")
        return
      }
      const loading = loadingService({ text: "请求中" })
      try {
        let res = await completeTask(
          this.taskId,
          {
            id: this.dataId,
            data: this.from
          },
          false
        )
        this.$message.success("保存成功！")
        this.$emit("after-submit", res || {}, this.from)
        this.close()
      } finally {
        loading.close()
      }
      this.$emit("after-submit", {}, this.from)
      this.close()
    },
    close() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped lang="scss">
.due-reason-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
